import * as React from 'react';
import { useCallback } from 'react';
import { ArticleParagraph1, UIHeading2 } from '@cian/ui-kit/typography';
import { IconChevronDownSmall16 } from '@cian/ui-kit/icons';
import { mergeStyles } from '@cian/utils';

import { getDescriptionText, isLongDescription } from '../../../../utils/description';

import * as styles from './styles.css';

interface IDescriptionMobileProps {
  text: string;
  className?: string;
  onExpandClick?: () => void;
}

export const DescriptionMobile: React.FunctionComponent<React.PropsWithChildren<IDescriptionMobileProps>> = props => {
  const { text, className, onExpandClick } = props;
  const [textMinimized, setTextMinimized] = React.useState(isLongDescription(text));
  const onExpandClickHandler = useCallback(() => {
    setTextMinimized(false);
    if (onExpandClick) {
      onExpandClick();
    }
  }, [onExpandClick]);

  return (
    <div {...mergeStyles(styles['container'], className)}>
      <div className={styles['header']}>
        <UIHeading2>О себе</UIHeading2>
      </div>
      <ArticleParagraph1>{getDescriptionText(text, textMinimized)}</ArticleParagraph1>
      {textMinimized && (
        <div className={styles['expand']} onClick={onExpandClickHandler}>
          <ArticleParagraph1 color="text-main-default">
            Читать дальше
            <span className={styles['expand_icon']}>
              <IconChevronDownSmall16 color="icon-main-default" />
            </span>
          </ArticleParagraph1>
        </div>
      )}
    </div>
  );
};
